import React from 'react';
import type ServicedeskReportsType from '@atlassian/jira-spa-apps-servicedesk-reports/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReports = lazyForPaint<typeof ServicedeskReportsType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-reports", jiraSpaEntry: "async-servicedesk-reports" */ '@atlassian/jira-spa-apps-servicedesk-reports'
		),
);
type Props = RouteContext;

/**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */

const AsyncServicedeskReports = ({ match }: Props): React.JSX.Element => {
	const oldIssueView = `/${(match.query && match.query.oldIssueView) || ''}`;
	return (
		<LazyPage
			Page={LazyServicedeskReports}
			pageId={`spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskReports;
